import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
    fetchContactEnquiry,
    updateContactEnquiry,
    
} from "@/services/contactUsEnquiry";
@Module({
    namespaced: true,
})
export default class Partner extends VuexModule {
    // state
    contactEnquiryList = {};

    // actions

    @Action
    public async fetchContactEnquiryList(payload: any) {
        try {
            const data = await fetchContactEnquiry(payload);
            this.context.commit("contactEnquiryData", data.data);
            return data;
        } catch (error) {
            throw error;
        }
    }
    @Action
    public async changeContactEnquiryStatus(payload: any) {
        try {
            const data = await updateContactEnquiry(payload);
            return data;
        } catch (error) {
            throw error;
        }
    }
    

    // mutations
    @Mutation
    public contactEnquiryData(data: any) {
        this.contactEnquiryList = data;
    }


    // getters
    get GetPortfolios() {
        return this.contactEnquiryList;
    }
}
